
import { useCallback, useState } from 'react';
import { Button, Tooltip } from 'tdesign-react';

import { BotGeneratorIcon } from '@/components/icon';
import { IBot } from '@/interface';
import { useAppDispatch, useTypedSelector } from '@/store';
import { setBotLoading } from '@/store/modules/bot';

import BotGeneratorInner from './botGeneratorInner';
import styles from './styles/index.module.less';

interface IBotGeneratorProps {
  onComplete: (value: Partial<IBot>) => void;
}

const BotGenerator = (props: IBotGeneratorProps) => {
  const { onComplete } = props;
  const dispatch = useAppDispatch();
  const { loading } = useTypedSelector(store => store.bot);

  const [count, setCount] = useState(0);

  const handleBegin = useCallback(() => {
    dispatch(setBotLoading(true));
  }, []);

  const handleClick = useCallback(() => {
    setCount(pre => pre + 1);
  }, []);

  const handleComplete = useCallback((value: Partial<IBot>) => {
    onComplete(value);
  }, [onComplete]);

  return <Tooltip
    overlayInnerClassName={styles.customTooltip}
    destroyOnClose={false}
    placement='bottom-left'
    trigger="click"
    triggerElement={
      <Button
        loading={loading}
        icon={<BotGeneratorIcon style={{ marginRight: 6 }} />}
        onClick={handleClick}
        className={styles.btn}>
        一键智能创作
      </Button>
    } content={
      <BotGeneratorInner
        autoSubmit={false}
        onBegin={handleBegin}
        onComplete={handleComplete}
        focusNum={count}
      />
    }>
  </Tooltip>;
};

export default BotGenerator;
